export enum AssessmentReminderStatus {
  dismissed = 'dismissed',
  displayed = 'displayed',
}
